// extracted by mini-css-extract-plugin
export default {"header":"SP0FwoQfGDlSQFDDr0Cg","rows":"JWUbrQW7seOvU70vafkA"};